export default __webpack_public_path__ + "static/media/20d807b5098c002bfe9f392a11de6831.jpg";